export default __webpack_public_path__ + "assets/d968e3bef084e73f35aff3d06f9d8874.png";